export default __webpack_public_path__ + "static/media/noChart.85c6c655.svg";